import { modals } from '@mantine/modals'
import { handleMutationError } from '@v2/commons/utils/errorHandling/handleMutationError'
import { showSuccessNotification } from '@v2/domains/notification/notification.hook'

import { useDeleteEscalationMutation } from '../api/escalation.api'

const useDeleteEscalation = () => {
  const [deleteTagMutation, { status }] = useDeleteEscalationMutation()

  const deleteEscalation = async (escalation: string) => {
    try {
      await deleteTagMutation(escalation).unwrap()
      showSuccessNotification('Escalation succesfuly deleted!')
      modals.closeAll()
    } catch (err) {
      handleMutationError(
        err,
        'Error deleting Escalation',
        () => modals.closeAll(),
        'Close',
      )
    }
  }

  return {
    deleteEscalation,
    deleteMutationStatus: status,
  }
}
export default useDeleteEscalation
